import React from 'react';
import { Box, Typography, Stack, TextField } from '@mui/material';

interface TimingInfoSectionProps {
  procedureStart: string;
  procedureDuration: string;
  procedureEnd: string;
  isDisabled: boolean;
  onStartChange: (value: string) => void;
  onDurationChange: (value: string) => void;
}

export const TimingInfoSection: React.FC<TimingInfoSectionProps> = ({
  procedureStart,
  procedureDuration,
  procedureEnd,
  isDisabled,
  onStartChange,
  onDurationChange
}) => {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: '#1e293b' }}>
        Timing Information
      </Typography>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2}>
          <TextField
            label="Start Time"
            type="datetime-local"
            size="small"
            value={procedureStart}
            onChange={(e) => onStartChange(e.target.value)}
            disabled={isDisabled}
            sx={{
              flex: 1,
              '& .MuiInputBase-input': {
                backgroundColor: isDisabled ? '#f5f5f5' : 'inherit'
              }
            }}
            InputLabelProps={{ shrink: true }}
            helperText={isDisabled ? 'Read-only (Encounter Cancelled)' : ''}
          />
          <TextField
            label="Duration (minutes)"
            type="number"
            size="small"
            value={procedureDuration}
            onChange={(e) => onDurationChange(e.target.value)}
            disabled={isDisabled}
            sx={{
              flex: 1,
              '& .MuiInputBase-input': {
                backgroundColor: isDisabled ? '#f5f5f5' : 'inherit'
              }
            }}
            inputProps={{ min: 0, step: 1 }}
            helperText={isDisabled ? 'Read-only (Encounter Cancelled)' : ''}
          />
        </Stack>
        <TextField
          label="End Time (Calculated)"
          type="datetime-local"
          size="small"
          value={procedureEnd}
          sx={{ flex: 1 }}
          InputLabelProps={{ shrink: true }}
          InputProps={{ readOnly: true }}
          helperText="Automatically calculated based on start time and duration"
          disabled
        />
      </Stack>
    </Box>
  );
};
